export default {
  toggleOrder: (state, id) => {
    state.account.selected_order = state.account.selected_order == id ? false : id
  },
}
